__turbopack_context__.v({
  "centerAligned": "Intro-module-scss-module__xoX77a__centerAligned",
  "intro": "Intro-module-scss-module__xoX77a__intro",
  "leftAligned": "Intro-module-scss-module__xoX77a__leftAligned",
  "links": "Intro-module-scss-module__xoX77a__links",
  "tag": "Intro-module-scss-module__xoX77a__tag",
  "text": "Intro-module-scss-module__xoX77a__text",
});
